import classNames from 'classnames';
import { Icon, SvgAnimation } from '@/components/standalone';
import { useRef } from 'react';
import useOnScreen from '@/helpers/useOnScreen';
import styles from '@/styles/personae.module.scss';

function AuditorsMonitoringSection() {
  const headingRef = useRef();
  const { isOnScreen: isHeadingOnScreen } = useOnScreen({
    ref: headingRef,
    threshold: 0.3,
    rootMargin: '0px',
    isOnce: true,
  });

  const animationRef = useRef();
  const { isOnScreen: isAnimationOnScreen } = useOnScreen({
    ref: animationRef,
    threshold: 0.5,
    rootMargin: '0px',
    isOnce: true,
  });

  return (
    <div className={classNames('section', styles.personaeSection)}>
      <div className={classNames('max-content-width', styles.invert)}>
        <div
          ref={animationRef}
          className={classNames(
            styles.personaeSectionAnimation,
            styles.personaeSectionAnimationMonitoring,
          )}
        >
          <SvgAnimation
            name="CriticalStateMonitoring"
            autoplay={isAnimationOnScreen}
            onComplete={(animation) => {
              animation.playSegments(
                [2.79 * 60, animation.getDuration() * 60],
                true,
              );
              // eslint-disable-next-line no-param-reassign
              animation.loop = true;
            }}
          />
        </div>
        <div
          className={classNames(styles.personaeSectionText, {
            [styles.personaeSectionTextAppear]: isHeadingOnScreen,
          })}
          ref={headingRef}
        >
          <div className="tb-tag">
            <Icon name="ScanEye" />
            CRITICAL STATE MONITORING
          </div>
          <h2>Make your audits timeless</h2>
          <p>
            Our critical state monitoring allows you to configure the conditions
            under which your audit should automatically be flagged with a
            violation or a critical issue. This enables your audits to be more
            responsive to state updates and contract upgrades, giving you
            greater control over your auditing process.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AuditorsMonitoringSection;
